export const COLOR_PICKER_TAG_NAME = "color-picker" as const;

export const DEFAULT_COLOR = "#000000";

export const COLOR_PICKER_LAYOUTS = ["field", "swatch"] as const;

export const ARROW_SIZES: Record<"sm" | "md" | "lg", number> = {
  sm: 6,
  md: 8,
  lg: 10,
};

export const AREA_SIZES: Record<"sm" | "md" | "lg", number> = {
  sm: 160,
  md: 200,
  lg: 240,
};

export const SWATCH_SIZE = 24;

export const AREA_THUMB_SIZE = 16;

export const HUE_TRACK_GRADIENT =
  "linear-gradient(to right, hsl(0, 100%, 50%), hsl(60, 100%, 50%), hsl(120, 100%, 50%), hsl(180, 100%, 50%), hsl(240, 100%, 50%), hsl(300, 100%, 50%), hsl(360, 100%, 50%))";

export const WHEEL_SIZES: Record<"sm" | "md" | "lg", number> = {
  sm: 160,
  md: 200,
  lg: 240,
};

export const WHEEL_THUMB_SIZE = 14;

// Hue around the disc: 0° at the top, growing clockwise
export const HUE_WHEEL_GRADIENT =
  "conic-gradient(hsl(0, 100%, 50%), hsl(60, 100%, 50%), hsl(120, 100%, 50%), hsl(180, 100%, 50%), hsl(240, 100%, 50%), hsl(300, 100%, 50%), hsl(360, 100%, 50%))";

// Saturation along the radius: white at the center, fully saturated at the
// edge. Both stops are white so the alpha ramp doesn't fringe through grey.
export const SATURATION_WHEEL_GRADIENT =
  "radial-gradient(circle closest-side, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))";
